import { useGetDashboardModel } from "@sisense/sdk-ui";

const useIndividualTimesSearchProgressionDashboard = (dashboardOid) => {
  const { dashboard, isLoading, isError } = useGetDashboardModel({ dashboardOid, includeWidgets: true });

  return {
    dashboard, isError, isLoading
  };
};

export default useIndividualTimesSearchProgressionDashboard;